import React, { forwardRef } from 'react';

const InputField = forwardRef(
  (
    { error, className = 'form-input', placeholder, children, as: Component = 'input', ...rest },
    ref
  ) => {
    return (
      <>
        <style>{`
        .custom-floating-container {
          position: relative;
          width: 100%;
        }
        .custom-floating-input {
          border-radius: 4px !important;
          border: 1px solid var(--border-default-weak, #666666) !important;
          padding: 14px 12px !important;
          font-family: 'Gotham', sans-serif;
          width: 100%;
          box-sizing: border-box;
        }
        .custom-floating-input:focus {
          outline: none !important;
          border: 2px solid var(--border-default-strong, #000000) !important;
          box-shadow: none !important;
        }
        .custom-floating-label {
          position: absolute;
          left: 8px;
          font-family: 'Gotham', sans-serif;
          top: 50%;
          transform: translateY(-50%);
          transition: top 0.2s ease, font-size 0.2s ease, transform 0.2s ease;
          pointer-events: none;
          color: #666666;
          background-color: #fff;
          padding: 0 4px;
          margin: 0;
        }
        .custom-floating-input:focus ~ .custom-floating-label,
        .custom-floating-input:not(:placeholder-shown) ~ .custom-floating-label {
          top: 0;
          font-size: 11px;
          color: #666;
        }
        .custom-floating-input:focus ~ .custom-floating-label {
          color: #000;
        }
      `}</style>
        <div className="custom-floating-container">
          <Component
            className={`custom-floating-input ${className}`}
            ref={ref}
            placeholder=" "
            {...rest}
          />
          {placeholder && <label className="custom-floating-label">{placeholder}</label>}
          {children}
        </div>
        {error && (
          <div className="form-text text-danger" role="alert">
            {error.message || error}
          </div>
        )}
      </>
    );
  }
);

InputField.displayName = 'InputField';

export default InputField;
